import { RootState } from '~/store/types';

export const REDUCER_NAME = 'timeLimit';

export type TimeLimitState = {
	[REDUCER_NAME]: {
		refetchTimers: boolean;
		timeLimitExceeded: boolean;
		timeLimitHydrated: boolean;
		proactiveTimeLimitWarningPopUpData: {
			title: string;
			description: string;
			ctaLabel: string;
			autoHideDuration?: number;
		} | null;
	};
};

export const selectProactiveTimeLimitWarningPopUpData = (state: RootState) =>
	(state as TimeLimitState)[REDUCER_NAME].proactiveTimeLimitWarningPopUpData;
